import { render, staticRenderFns } from "./SubfolderDelete.vue?vue&type=template&id=4fe04049"
import script from "./SubfolderDelete.vue?vue&type=script&lang=js"
export * from "./SubfolderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports